import axios from 'axios'

import { unique } from '@/helpers/api'
import type { Bucket, UUID } from '@/types'

export interface S3ImportParameters {
  corpus_id: UUID
  element_id?: UUID | null
  folder_type?: string
  element_type?: string
  farm_id?: UUID | null
  configuration?: Record<string, unknown>
}

// Retrieve available s3 buckets
export const listBuckets = unique(
  async (): Promise<Bucket[]> => (await axios.get('/ingest/buckets/')).data,
)

// Run a file import process from a bucket
export const importFromBucket = async (payload: S3ImportParameters): Promise<UUID> =>
  (await axios.post('/ingest/create/', payload)).data.id
